import React, { useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Select from "react-dropdown-select";
import { CheckCircleIcon } from "@heroicons/react/solid";
import Button from "../button/button";
import Box from "@mui/material/Box";
import { connect, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import { upgradeAccount } from "../../redux/actions/upgrade";
import ErrorMessage from "../message/message";
import { LocalStorageService } from "../../services";
const optionsByType = {
  FREE: [
    {
      value: "STANDARD",
      label: "STANDARD",
    },
    {
      value: "PREMIUM",
      label: "PREMIUM",
    },
  ],
  STANDARD: [
    {
      value: "PREMIUM",
      label: "PREMIUM",
    },
  ],
  PREMIUM: [],
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  overflow: "none",
  marginTop: "2%",
  marginBottom: "2%",
};

let subscriptionTypes = [
  {
    name: "Quarterly",
    type: "quarterly",
  },
  {
    name: "Annually",
    type: "yearly",
  },
];

// get step data from redux main state
const data = (state) => state.auth;

let UpgradeCard = (props) => {
  const [selectedValue, setValue] = useState([]);
  const [subscriptionName, setSubscriptionName] = useState("Annually");
  const [subscriptionType, setSubscriptionType] = useState("yearly");
  const [openModal, setOpenModal] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [userDataType, setUserDataType] = React.useState(true);
  let authData = useSelector(data);

  let { type } = props;

  useEffect(() => {
    let userDataType = authData && authData.client && authData.client.userType;
    userDataType = userDataType.toUpperCase();
    setUserDataType(userDataType);
  }, [props]);

  let upgrageAccount = () => {
    setLoading(true);
    let subscription = subscriptionType.toLocaleLowerCase();
    let subsType = selectedValue[0] && selectedValue[0].value;
    if (subsType && subscriptionType) {
      let { client } = authData;
      subsType = subsType.toLowerCase();
      let upgradeObj = {
        name: client.name,
        phone: client.phone,
        email: client.email,
        type: subsType,
        company: "",
        subscription,
      };
      setTimeout(() => {
        setLoading(false);
      }, 2000);

      props.upgradeAccount(upgradeObj);
    } else {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={() => {
        setOpenModal(false);
        props.onCloseUpgrade();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        className="border-4 border-[#0094A5] rounded-lg bg-white shadow-md  2xl:w-4/12 xl:w-4/12 lg:w-4/12 md:w-6/12 w-8/12 my-14"
      >
        <div className="border-[3px] border-[#FFD700] rounded-md">
          <div className="flex justify-end items-center px-4 py-3">
            <button onClick={() => props.onCloseUpgrade()}>
              <AiOutlineCloseCircle color="#0094A5" size={25} />
            </button>
          </div>

          <div className="px-12 py-2">
            <p className="text-[#515556] text-2xl font-semibold text-center">
              It’s Time For You To Upgrade!
            </p>

            <p className="text-[#878787] text-lg text-center mt-1">
              Your current version is{" "}
              <span className="font-semibold uppercase text-[#007E8B]">
                {type ? type : ""}
              </span>
            </p>

            <p className="text-[#878787] text-sm text-center my-2">
              Please upgrade your current plan to unlock more features.
            </p>
            <div className="my-6 px-14">
              <Select
                values={selectedValue}
                options={optionsByType[userDataType]}
                onChange={(values) => setValue(values)}
                isSearchable="false" // searchable for the closest one
                style={{ fontWeight: "bold" }}
              />
            </div>

            <div className="flex justify-center items-center">
              {subscriptionTypes &&
                subscriptionTypes.map((item, index) => {
                  return (
                    <button
                      onClick={() => {
                        setSubscriptionName(item.name);
                        setSubscriptionType(item.type);
                      }}
                      key={index}
                      className={`${item.name === subscriptionName
                          ? " mx-4 bg-[#FBD10B] text-[14px] tracking-wider uppercase px-6 py-3 text-[#047C8D] border-[3px]  rounded-md border-[#027D8A] justify-center items-center  font-bold"
                          : "mx-4 bg-[#FFD700] text-[14px] tracking-wider uppercase px-6 py-3 text-[#BEA000] border-[3px] border-[#FFD700]  rounded-md  justify-center items-center font-semibold "
                        }`}
                    >
                      {item.name}
                    </button>
                  );
                })}
            </div>

            {selectedValue[0] && selectedValue[0].value === "FREE" ? (
              <div className="my-4">
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    25 Candidate Assessments
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    1 Assessment Game
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Access to our Test Library
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Single Email Invite Feature
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    Single invite per email
                  </span>
                </div>
              </div>
            ) : selectedValue[0] && selectedValue[0].value === "PREMIUM" ? (
              <div className="my-4 relative">
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    1200 Candidate Assessments
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    2 Assessment Games
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Access to our Test Library
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Pre selected fields of data collection
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Customizable fields
                  </span>
                </div>
                <div className="absolute right-[10px] top-[28px]">
                  {selectedValue[0].value === "PREMIUM" &&
                    subscriptionName === "Quarterly" ? (
                    <p class="text-[#FEBB12] text-[3.2rem] font-bold">
                      1500<sup class="text-[2rem] font-bold top-[-2rem]">$</sup>
                    </p>
                  ) : (
                    <p class="text-[#FEBB12] text-[3.2rem] font-bold">
                      4800<sup class="text-[2rem] font-bold top-[-2rem]">$</sup>
                    </p>
                  )}
                </div>

              </div>
            ) : selectedValue[0] && selectedValue[0].value === "STANDARD" ? (
              <div className="my-4 relative">
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    300 Candidate Assessments
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    1 Assessment Game
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    Access to our Test Library
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    Select Data Collection Fields
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345]  font-semibold">
                    Company Branded Game URL
                  </span>
                </div>

                <div className="absolute right-[10px] top-[28px]">
                  {selectedValue[0].value === "STANDARD" &&
                    subscriptionName === "Quarterly" ? (
                    <p class="text-[#FEBB12] text-[3.2rem] font-bold">
                      400<sup class="text-[2rem] font-bold top-[-2rem]">$</sup>
                    </p>
                  ) : (
                    <p class="text-[#FEBB12] text-[3.2rem] font-bold">
                      1200<sup class="text-[2rem] font-bold top-[-2rem]">$</sup>
                    </p>
                  )}
                </div>
              </div>
            ) : null}

            {error ? (
              <div className="w-max mx-auto mt-12">
                <ErrorMessage
                  onClick={() => setError(false)}
                  text={"To proceed, choose a plan above."}
                />
              </div>
            ) : null}

            {selectedValue[0] &&
              selectedValue[0].value === userDataType ? null : (
              <div className="flex justify-center items-center mt-6">
                <Button
                  type="button"
                  customStyle="mb-4 2xl:w-6/12 xl:w-6/12 lg:w-6/12 md:w-10/12 w-11/12 "
                  name={`${loading ? "Please Wait" : "Upgrade Now"}`}
                  onClick={upgrageAccount}
                />
              </div>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  upgradeAccount,
})(UpgradeCard);
